// Which Pricer fields are editable or hidden per row level (summary / leg /
// sub-leg) and for options with more than two legs. Data only (A2-1600).

import { FIELD_NAMES, GREEKS_COLUMNS_FIELDS_NAME } from "./fields";

const COMMON_EDITABLE_FIELDS_BASED_ON_LEVEL = [
  FIELD_NAMES.BID,
  FIELD_NAMES.BID_PERCENTAGE,
  FIELD_NAMES.ASK,
  FIELD_NAMES.ASK_PERCENTAGE,
];

export const EDITABLE_FIELDS_BASED_ON_LEVEL = {
  [FIELD_NAMES.SUMMARY]: [
    ...COMMON_EDITABLE_FIELDS_BASED_ON_LEVEL,
    FIELD_NAMES.BID_QTY,
    FIELD_NAMES.ASK_QTY,
    FIELD_NAMES.RISK_FREE,
    FIELD_NAMES.UNDERLYING,
  ],
  [FIELD_NAMES.LEG]: [
    ...COMMON_EDITABLE_FIELDS_BASED_ON_LEVEL,
    FIELD_NAMES.STRIKE,
    FIELD_NAMES.UNDERLYING,
    FIELD_NAMES.RATIO,
  ],
  [FIELD_NAMES.SUB_LEG]: [
    ...COMMON_EDITABLE_FIELDS_BASED_ON_LEVEL,
    FIELD_NAMES.UNDERLYING,
  ],
};

export const HIDE_VALUES_BASED_ON_LEVEL = {
  [FIELD_NAMES.SUMMARY]: [
    GREEKS_COLUMNS_FIELDS_NAME.ASK_TOTAL_QTY,
    GREEKS_COLUMNS_FIELDS_NAME.BID_TOTAL_QTY,
    GREEKS_COLUMNS_FIELDS_NAME.ASK_BREAKEVEN,
    GREEKS_COLUMNS_FIELDS_NAME.BID_BREAKEVEN,
    GREEKS_COLUMNS_FIELDS_NAME.BID_RHO,
    GREEKS_COLUMNS_FIELDS_NAME.ASK_RHO,
    GREEKS_COLUMNS_FIELDS_NAME.BID_VEGA,
    GREEKS_COLUMNS_FIELDS_NAME.ASK_VEGA,
    GREEKS_COLUMNS_FIELDS_NAME.BID_THETA,
    GREEKS_COLUMNS_FIELDS_NAME.ASK_THETA,
  ],
  [FIELD_NAMES.LEG]: [
    FIELD_NAMES.LIVE,
    FIELD_NAMES.IS_LOCKED,
    FIELD_NAMES.IS_AUTO_UPDATE_VOL,
    FIELD_NAMES.ACTIONS,
  ],
  [FIELD_NAMES.SUB_LEG]: [
    GREEKS_COLUMNS_FIELDS_NAME.BID_TOTAL_PREMIUM,
    GREEKS_COLUMNS_FIELDS_NAME.ASK_TOTAL_PREMIUM,

    GREEKS_COLUMNS_FIELDS_NAME.ASK_TOTAL_QTY,
    GREEKS_COLUMNS_FIELDS_NAME.BID_TOTAL_QTY,

    GREEKS_COLUMNS_FIELDS_NAME.ASK_RHO_CURRENCY,
    GREEKS_COLUMNS_FIELDS_NAME.BID_RHO_CURRENCY,

    GREEKS_COLUMNS_FIELDS_NAME.ASK_VEGA_CURRENCY,
    GREEKS_COLUMNS_FIELDS_NAME.BID_VEGA_CURRENCY,

    GREEKS_COLUMNS_FIELDS_NAME.ASK_BREAKEVEN,
    GREEKS_COLUMNS_FIELDS_NAME.BID_BREAKEVEN,

    GREEKS_COLUMNS_FIELDS_NAME.ASK_DELTA_QTY,
    GREEKS_COLUMNS_FIELDS_NAME.BID_DELTA_QTY,

    GREEKS_COLUMNS_FIELDS_NAME.ASK_GAMMA_QTY,
    GREEKS_COLUMNS_FIELDS_NAME.BID_GAMMA_QTY,

    GREEKS_COLUMNS_FIELDS_NAME.BID_THETA_CURRENCY,
    GREEKS_COLUMNS_FIELDS_NAME.ASK_THETA_CURRENCY,

    FIELD_NAMES.BID_QTY,
    FIELD_NAMES.ASK_QTY,

    FIELD_NAMES.PRODUCT,
    FIELD_NAMES.CONTRACT,
    FIELD_NAMES.STYLE,
    FIELD_NAMES.RISK_FREE,
    FIELD_NAMES.LIVE,
    FIELD_NAMES.IS_AUTO_UPDATE_VOL,
    FIELD_NAMES.TYPE,
    FIELD_NAMES.RATIO,

    FIELD_NAMES.IS_LOCKED,

    FIELD_NAMES.ACTIONS,
    FIELD_NAMES.STRIKE,
  ],
};

export const HIDE_VALUES_IN_SUBLEGS = [FIELD_NAMES.PRODUCT];
export const UNEDITABLE_FIELDS_BASED_ON_MORE_THAN_TWO_LEGS = [
  FIELD_NAMES.BID_PERCENTAGE,
  FIELD_NAMES.ASK_PERCENTAGE,
  FIELD_NAMES.TENOR,
];

export const HIDE_VALUES_BASED_FOR_MORE_THAN_TWO_LEGS = [
  FIELD_NAMES.TENOR,
  FIELD_NAMES.UNDERLYING,
  FIELD_NAMES.BID_PERCENTAGE,
  FIELD_NAMES.ASK_PERCENTAGE,
];
